<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
                <CCol class="d-flex justify-content-end">
                    <ButtonCreate
                        :title="$t('Add badword to blacklist')"
                        @click="modals.addBadwordToBlacklist.show = true"
                    >
                        {{ $t("Add badword") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.badwordBlacklist.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'badwordBlacklist',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="
                                            tables.badwordBlacklist.allFields
                                        "
                                        :activeFields.sync="
                                            tables.badwordBlacklist.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.badwordBlacklist.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.badwordBlacklist.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :items-per-page="tables.badwordBlacklist.rows"
                                    :loading="tables.badwordBlacklist.loading"
                                    v-bind="tables.badwordBlacklist"
                                    :columnFilterValue.sync="
                                        tables.badwordBlacklist.columnFilterValue
                                    "
                                    :sorterValue.sync="
                                        tables.badwordBlacklist.sorterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                >
                                    <template #no-items-view>
                                        <div class="block-no-items section">
                                            <h2
                                                class="section__title text-no-items"
                                            >
                                                {{
                                                    $t(
                                                        "create_badwordBlacklist_for_your_api_integrations"
                                                    )
                                                }}
                                            </h2>
                                            <CButton
                                                color="success"
                                                class="button m-2 shadow"
                                                @click="
                                                    $router.push({
                                                        name: 'add_trigger',
                                                    })
                                                "
                                            >
                                                <span class="button__icon">
                                                    <CIcon
                                                        :content="
                                                            $options.icons
                                                                .cilPlus
                                                        "
                                                    />
                                                </span>
                                                <span class="button__text">
                                                    {{ $t("add_trigger") }}
                                                </span>
                                            </CButton>
                                        </div>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="trigger.api/statistics"
                                                :table="tables.badwordBlacklist"
                                            />
                                        </div>
                                    </template>
                                    <template #_selected="{ item }">
                                        <td class="py-2">
                                            <CInputRadio
                                                name="_selected"
                                                :checked="
                                                    item ===
                                                    tables.badwordBlacklist
                                                        .itemSelected
                                                "
                                                @update:checked="
                                                    selectItemTable(
                                                        'badwordBlacklist',
                                                        item
                                                    )
                                                "
                                            />
                                        </td>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.badwordBlacklist.total_pages > 0"
                            >
                                <CPagination
                                    @update:activePage="updatePagination"
                                    :activePage="tables.badwordBlacklist.page"
                                    :pages="tables.badwordBlacklist.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
                <AddBadwordToBlacklistModal
                    :show.sync="modals.addBadwordToBlacklist.show"
                    v-bind="modals.addBadwordToBlacklist"
                    v-on:submit="afterPhoneAddingToBlacklist"
                    :title="$t('Add badword to blacklist')"
                />
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'badwordBlacklist',
                    })
                "
            >
                <template #title>
                    {{ $t("Add badword to blacklist") }}
                </template>
                <template #description>
                    {{ $t("You can add an badword to blacklist.") }}
                </template>
                <template #redirect>
                    <ButtonCreate
                        @click="modals.addBadwordToBlacklist.show = true"
                    >
                        {{ $t("Add badword") }}
                    </ButtonCreate>
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'badwordBlacklist',
                            })
                        "
                        @click="
                            cleanFiltersAdvance('badwordBlacklist'), updateData()
                        "
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean filters") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";
import FilterFields from "~/components/FilterFields";
import NoItemsContainer from "~/components/NoItemsContainer";
import AddBadwordToBlacklistModal from "../Components/AddBadwordToBlacklistModal.vue";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilReload,
    cilPencil,
    cilChart,
    cilTrash,
    cilArrowThickFromRight,
    cilMediaStop,
    cilMediaPlay,
} from "@coreui/icons";

import BadwordBlacklistTable from "../Config/Tables/BadwordBlacklist";

export default {
    name: "PhonessBlacklistPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ButtonCreate,
        TableSettings,
        ButtonExport,
        FilterFields,
        NoItemsContainer,
        AddBadwordToBlacklistModal,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
        cilReload,
        cilChart,
        cilMediaPlay,
        cilMediaStop,
    },
    data() {
        return {
            tables: {
                badwordBlacklist: BadwordBlacklistTable,
            },
            modals: {
                addBadwordToBlacklist: {
                    show: false,
                    color: "primary",
                    size: "lg",
                },
            },
        };
    },
    computed:{
        titlePage: function () {
            return "Badwords blacklist";
        },
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.badwordBlacklist.rows = newValue;
            this.updatePagination(this.tables.badwordBlacklist.page);
        },
        async updatePagination(newValue) {
            this.tables.badwordBlacklist.page = newValue;
            await this.updateData();
        },
        async updateData() {
            await this.updateTable({
                tableName: "badwordBlacklist",
                url: "/headers.api/blacklist/badwords",
            });
            this.tables.badwordBlacklist.itemSelected = null;
            this.tables.badwordBlacklist.loading = false;
            this.updatePageLoading(false);
        },

        afterPhoneAddingToBlacklist(response) {
            this.modals.addBadwordToBlacklist.show = false;
            this.updateData();
        },
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style scoped lang="scss">
</style>